import { render, staticRenderFns } from "./RNPLayout.vue?vue&type=template&id=0ec67640"
import script from "./RNPLayout.vue?vue&type=script&lang=ts"
export * from "./RNPLayout.vue?vue&type=script&lang=ts"
import style0 from "./RNPLayout.vue?vue&type=style&index=0&id=0ec67640&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports